<template>
    <div v-if="loading" style="z-index: 0" class="bg-white text-center p-20 text-gray-600">
        <button type="button" class="inline-flex items-center px-4 py-2 font-semibold leading-6 text-sm shadow rounded-md text-white bg-gray-500 hover:bg-gray-400 transition ease-in-out duration-150 cursor-not-allowed" disabled="">
            <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Wczytuję...
        </button>
    </div>

    <div v-if="!loading" style="z-index: 0" class="bg-white">
        <div class="max-w-7xl mx-auto overflow-hidden ">
            <h2 class="sr-only">Products</h2>
            <div v-if="products?.length > 0" class="-z-50  -mx-px border-l border-t border-gray-200 grid grid-cols-2 sm:mx-0 md:grid-cols-3 xl:grid-cols-4">
                <ProductTile v-for="product in products" :key="product.id"
                    :product_id="product.product_id"
                    :category_id="product.category_id"
                    :department_id="product.department_id"
                    :department_name="product.department_name"
                    :discount="product.discount"
                    :ean="product.ean"
                    :image_src="product.image_src"
                    :name="product.name"
                    :online_shop_href="product.online_shop_href"
                    :price="product.price"
                    :promo_end="product.promo_end"
                    :promo_price="product.promo_price"
                    :promo_start="product.promo_start"
                    :stock_bar="product.stock_bar"
                    :stock_color="product.stock_color"
                    :stock_name="product.stock_name"
                />
            </div>
            <Pagination v-if="lastPage > 1" :total="total" :currentPage="currentPage" :lastPage="lastPage" :perPage="perPage" @pageChange="changePage" />
            <div v-if="products?.length === 0" class="text-center p-10 text-gray-600">Nie znaleziono produktów spełniających kryteria!</div>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue';
import {StarIcon} from '@heroicons/vue/solid'
import Battery from "../elements/Battery";
import SelectDepartment from "./SelectDepartment";
import Pagination from '../elements/Pagination';
import ProductTile from '../elements/ProductTile';

export default {
    components: {
        SelectDepartment,
        Battery,
        StarIcon,
        Pagination,
        ProductTile,
    },
    setup(props) {
        let loading = ref( true );
        let products = ref( null );
        let total = ref(0);
        let perPage = ref(0);
        let currentPage = ref(1);
        let lastPage = ref(0);

        const productsEndpoint = ref('https://cloudpanel.pl/api/uchowanca/products');
        let params = [];
        if (props.category) params.push(`category=${encodeURIComponent(props.category)}`);
        if (props.type) params.push(`type=${encodeURIComponent(props.type)}`);
        if (props.department) params.push(`department=${parseInt(props.department, 10)}`);
        if (props.priceFrom) params.push(`priceFrom=${parseInt(props.priceFrom, 10)}`);
        if (props.priceTo) params.push(`priceTo=${parseInt(props.priceTo, 10)}`);
        if (props.keywords) params.push(`keywords=${encodeURIComponent(props.keywords, 10)}`);

        fetch(`${productsEndpoint.value}?${params.join('&')}`).then(response => response.json())
        .then(result => {
            products.value = result.products;
            total.value = result.total;
            perPage.value = result.onPage;
            currentPage.value = result.currentPage;
            lastPage.value = result.lastPage;
            loading.value = false;
        });

        return {
            currentPage,
            lastPage,
            loading,
            perPage,
            products,
            productsEndpoint,
            total,
        }
    },
    props: {
        category: {
            type: String,
            required: false,
        },
        type: {
            type: String,
            required: false,
        },
        priceFrom: {
            type: [Number, String],
            required: false,
        },
        priceTo: {
            type: [Number, String],
            required: false,
        },
        department: {
            type: Number,
            required: false,
        },
        keywords: {
            type: String,
            required: false,
        },
        sort: {
            type: String,
            required: false,
        },
        showAvailable: {
            type: String,
            required: false,
        },
        withPhoto: {
            type: String,
            required: false,
        }
    },
    methods: {
        async reloadProducts(
            page = 1,
            category = null,
            type = null,
            department = null,
            keywords = null,
            sort = null,
            priceFrom = null,
            priceTo = null,
            showAvailable = null,
            withPhoto = null
        ) {
            this.loading = true;
            this.products = [];
            this.total = 0;
            this.perPage = 0;
            this.currentPage = 0;
            this.lastPage = 0;

            let params = [];
            if (category || this.category) params.push(`category=${encodeURIComponent(category || this.category)}`);
            if (type || this.type) params.push(`type=${encodeURIComponent(type || this.type)}`);
            if (showAvailable || this.showAvailable) params.push(`showAvailable=${showAvailable || this.showAvailable}`);
            if (withPhoto || this.withPhoto) params.push(`withPhoto=${withPhoto || this.withPhoto}`);
            if (priceFrom || this.priceFrom) params.push(`priceFrom=${priceFrom || this.priceFrom}`);
            if (priceTo || this.priceTo) params.push(`priceTo=${priceTo || this.priceTo}`);
            if (department || this.department) params.push(`department=${parseInt(department || this.department, 10)}`);
            if (keywords || this.keywords) params.push(`keywords=${encodeURIComponent(keywords || this.keywords, 10)}`);
            if (sort || this.sort) params.push(`sort=${encodeURIComponent(sort || this.sort, 10)}`);
            if (page) params.push(`page=${page}`);

            fetch(`${this.productsEndpoint}?${params.join('&')}`).then(response => response.json())
            .then(result => {
                this.products = result.products;
                this.total = result.total;
                this.perPage = result.onPage;
                this.currentPage = result.currentPage;
                this.lastPage = result.lastPage;
                this.loading = false;

            });
        },
        changePage(page) {
            window.scrollTo(0,0);
            setTimeout(() => {
                this.reloadProducts(page)
            }, 500);
        }
    },
    watch: {
        category (newCategory, oldCategory) {
            this.reloadProducts(1, newCategory);
        },
        type (newType, oldType) {
            this.reloadProducts(1, null, newType);
        },
        department (newDept, oldDept) {
            this.reloadProducts(1, null, null, newDept);
        },
        keywords (newkeywords, oldkeywords) {
            this.reloadProducts(1, null, null, null, newkeywords);
        },
        sort (newSorting, oldSorting) {
            this.reloadProducts(1, null, null, null, null, newSorting);
        },
        priceFrom (newPrice, oldPrice) {
            this.reloadProducts(1, null, null, null, null, null, newPrice);
        },
        priceTo (newPrice, oldPrice) {
            this.reloadProducts(1, null, null, null, null, null, null, newPrice);
        },
        showAvailable (newValue, oldValue) {
            this.reloadProducts(1, null, null, null, null, null, null, null, newValue);
        },
        withPhoto (newValue, oldValue) {
            this.reloadProducts(1, null, null, null, null, null, null, null, null, newValue);
        },
    }
}
</script>
